const state = {
    reload: true,
    pageSize: 9,
    pageIndex: 1,
    keyword: "",
    total: 0,
    portfolioList: [],
    chartType: ""
};

const mutations = {
    setPortfolioList(state, data) {
        state.portfolioList = data;
    },
    addPageIndex(state) {
        state.pageIndex++;
    },
    updateKeyword(state, data) {
        state.reload = true;
        state.keyword = data;
        state.pageIndex = 1;
        state.portfolioList = [];
    },
    setReload(state, data) {
        state.reload = data;
    },
    setTotal(state, data) {
        state.total = data;
    },
    setChartType(state, data) {
        state.chartType = data;
    }
};

const actions = {
    getPortfolioList({ commit, state }, { data, fetch }) {
        const params = new URLSearchParams({
            pageIndex: data && data.pageIndex ? data.pageIndex : state.pageIndex,
            pageSize: state.pageSize,
            keyword: state.keyword
        });
        return fetch({
            url: `/api/v1/Import/Portfolios?${params.toString()}`,
            method: "GET"
        });
    },
    getPortfolioAllocation({ commit }, { data, fetch }) {
        const { sourceId, portfolioId } = data;
        return fetch({
            url: `/api/v1/Import/${sourceId}/${portfolioId}/AssetAllocation`,
            method: "GET"
        });
    }
};

export default {
    state,
    mutations,
    actions
};
